import React from "react";
import ForbiddenPsalmGenerator from "./features/forbidden-psalms/components/ForbiddenPsalmGenerator";

function App() {
  return (
    <div>
      <ForbiddenPsalmGenerator />
    </div>
  );
}

export default App;